import React from "react";

import Mosque from './images/elements/Event/Mosque.png'
import Moon from './images/elements/Event/Moon Star.png'

import Top from './images/icons/up.png'
import Egypt from './images/icons/egypt.png'
import Dark from './images/icons/moon.png'

const Event = () => (
  <div className="eventmain">
    <div>
      <br /><br /><br />
      <img className="center" src={Mosque} width="400px" alt="Mosque" />
    </div>
    <div className="container">
      <div className="para">
        <div className="para1">
          <h2>Lorem, ipsum.</h2>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis
            at corporis iusto ea quia quis quod dolor cum sint illo dolorem id,
            soluta sed, dignissimos quo. Aliquid pariatur consequatur harum.
          </p>
        </div>
        <div className="para2">
          <h2>Lorem, ipsum.</h2>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis
            at corporis iusto ea quia quis quod dolor cum sint illo dolorem id,
            soluta sed, dignissimos quo. Aliquid pariatur consequatur harum.
          </p>
        </div>
        <div className="para3">
          <h2>Lorem, ipsum.</h2>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis
            at corporis iusto ea quia quis quod dolor cum sint illo dolorem id,
            soluta sed, dignissimos quo. Aliquid pariatur consequatur harum.
          </p>
        </div>
      </div>
      <div className="buttons">
        <div className="button">
          <button>Learn More</button>
          <button>Check Schedule</button>
        </div>
      </div>
      <div>
        <img
          className="center moonstar"
          src={Moon}
          alt="Moon Star"
        />
      </div>
    </div>
    <br />
    <div className="big-container">
      <div className="container1">
        <div className="tips-p">
          <h1>Tips on how to spend Dhul Hijjah</h1>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim, eos?
            Odio, excepturi pariatur! Incidunt ullam aliquam non qui excepturi
            eveniet aspernatur, optio cupiditate doloremque! Sit adipisci est
            dolore nobis, cumque reiciendis! Fuga eaque illo quod, dicta sed
            quia totam odit voluptatibus commodi, exercitationem obcaecati
            excepturi, nesciunt nulla. Cum, laborum laboriosam.
          </p>
        </div>
        <div className="point1">
          <h1 className="num">1</h1>
          <hr />
          <h2>Lorem, ipsum.</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Qui odit
            laboriosam vel quisquam laborum fugit quibusdam repellendus dolorum
            eligendi, natus magnam minus a ad ea, quis, veniam impedit incidunt
            soluta!
          </p>
        </div>
      </div>
      <br />
      <div className="container2">
        <div className="point2">
          <h1 className="num">2</h1>
          <hr />
          <h2>Lorem, ipsum.</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Qui odit
            laboriosam vel quisquam laborum fugit quibusdam repellendus dolorum
            eligendi, natus magnam minus a ad ea, quis, veniam impedit incidunt
            soluta!
          </p>
        </div>
        <br />
        <div className="point3">
          <h1 className="num">3</h1>
          <hr />
          <h2>Lorem ipsum dolor sit amet.</h2>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Hic quae
            consequatur tempora saepe perspiciatis autem veniam similique
            exercitationem eligendi natus, dignissimos magnam incidunt provident
            quisquam dolores beatae itaque nisi harum, voluptatum earum debitis
            cum? Adipisci, porro! Culpa, delectus. Ipsa reiciendis dolorem
            placeat voluptatibus illum aspernatur eius temporibus sequi optio
            numquam.
          </p>
        </div>
      </div>
    </div>
    
    <div className="features">
    <a href="#"> <img src={Top} width="40" style={{ border: 'none' }} id="toTop" className="test"/></a>
    <a href="#"> <img src={Egypt} width="40"/></a>
    <a href="#"> <img src={Dark} width="40"/></a>
    </div>

  </div>
);

export default Event;